import { lazy, Suspense } from "react";
import LoadingPage from "../containers/loading";

const Page = lazy(() =>
  import("../containers/deposit/massiveChangeView/massiveChangeView")
);

function MassiveChangeRoute() {
  return (
    <Suspense fallback={<LoadingPage />}>
      <Page />
    </Suspense>
  );
}

export default MassiveChangeRoute;
